import { useOnboardingContext } from '../context/OnboardingContext';

export default function ProgressBar() {
	const { currentPage } = useOnboardingContext();

	const steps: string[] = ['OUTREACH', 'OFFERING', 'VALUE', 'SIGNATURE'];

	const currentStepIndex = steps.indexOf(currentPage);

	const isPostSignature = currentPage === 'GENERATING';

	return (
		<div className="flex justify-center">
			<div className="flex w-full max-w-[79rem] items-center justify-center">
				<div className="flex h-4 w-full items-center justify-center gap-1 rounded-3xl border-2 border-dm-gray bg-dm-black4 p-1">
					{steps.map((step, index) => (
						<div
							key={step}
							data-filled={
								isPostSignature || index <= currentStepIndex
							}
							data-first={index === 0}
							data-last={index === steps.length - 1}
							className="h-2 flex-1 border-2 transition-all duration-300 data-[first=true]:rounded-l-md data-[last=true]:rounded-r-md data-[filled=false]:border-dm-mid-grey data-[filled=true]:border-dm-green data-[filled=false]:bg-dm-mid-grey data-[filled=true]:bg-dm-green"
						/>
					))}
				</div>
			</div>
		</div>
	);
}
